import ServiceScheduleException from 'interfaces/serviceScheduleException';
import moment from 'moment';
import { ChangeEvent, FC } from 'react';
import { datetimeFormat } from 'utils/datetime';

interface Option extends ServiceScheduleException {
  id: string;
  checked: boolean;
}

interface OverrideModalBodyProps {
  options: Option[];
  selectAllRef: React.MutableRefObject<HTMLInputElement | null>;
  handleChangeSelectAll: (e: ChangeEvent<HTMLInputElement>) => void;
  handleChangeCheckbox: (id: string, isChecked: boolean) => void;
  totalSelectOptions: number;
}

const OverrideModalBody: FC<OverrideModalBodyProps> = ({
  selectAllRef,
  options,
  handleChangeSelectAll,
  handleChangeCheckbox,
  totalSelectOptions,
}) => {
  const isYearInTheFuture = (dateString: string) => {
    return moment().isBefore(moment(dateString, 'YYYY-MM-DD'), 'years');
  };

  return (
    <>
      <div
        className={`border-b-[2px] border-grey pb-0.9 mt-2.4 grid grid-cols-[70px_150px_1fr] items-center`}
      >
        <div className="flex items-center">
          <input
            className="w-2.2 h-2.2"
            type="checkbox"
            id="selectAll"
            ref={selectAllRef}
            onChange={handleChangeSelectAll}
          />
          <span className="text-[1rem] leading-[1.8rem] ml-[6px]">
            ({totalSelectOptions})
          </span>
        </div>
        <span className="font-bold">Date</span>
        <span className="font-bold">Time Shifts</span>
      </div>
      <div className="max-h-[28rem] scrollbar overflow-auto text-darkest-grey ">
        {options.map((option, index) => (
          <div
            key={option.id}
            className={`grid grid-cols-[70px_150px_1fr] min-h-[4rem] py-0.6 items-center border-b border-b-light-grey ${
              index % 2 ? 'bg-lightest-grey' : 'bg-white'
            } `}
          >
            <input
              className="w-2.2 h-2.2"
              type="checkbox"
              id={option.id}
              checked={option.checked}
              onChange={(e) =>
                handleChangeCheckbox(option.id, e.target.checked)
              }
            />
            <label htmlFor={option.id}>
              {datetimeFormat({
                dateString: option.date,
                format: 'YYYY-MM-DD',
                pattern: `ddd, MMM DD${
                  isYearInTheFuture(option.date) ? ', YYYY' : ''
                }`,
              })}
            </label>
            <div className="flex flex-col gap-y-2">
              {option.shifts.map((shift) => {
                const isAvailable = shift.startTime && shift.endTime;
                if (!isAvailable) {
                  return (
                    <span
                      key={`${option.id}-${shift.startTime}`}
                      className="text-magenta"
                    >
                      Unavailable
                    </span>
                  );
                }
                return (
                  <div
                    className="flex justify-between gap-x-5 pr-2"
                    key={`${option.id}-${shift.startTime}`}
                  >
                    <span className="font-bold">
                      OP:{' '}
                      {shift.operatories.map((item) => item.name).join(', ')}
                    </span>
                    {
                      <span>
                        {moment(shift.startTime, 'HH:mm:ss').format('hh:mm A')}{' '}
                        - {moment(shift.endTime, 'HH:mm:ss').format('hh:mm A')}
                      </span>
                    }
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default OverrideModalBody;
